<template>
  <div>
    <a class="button full-width-button  is-primary" @click="openAddBannerDialog">
        <span class="icon is-small">
            <i class="fas fa-plus"></i>
        </span>
        <span>Add</span>
    </a>
      <div class="has-text-centered" >
    
      <img :src="'/static/nodata.gif'" v-if="!banners.length"  alt="No data Found" style="height : 200pt"> 
      <p class="subtitle" v-if="!banners.length">Photos not found in {{city.name}}</p>
      <hr v-if="!banners.length">
      </div> 
    <p v-if="isLoading">Loading banners...</p>
    <div class="columns mt-1 is-multiline" v-if="!isLoading">
        <div class="column is-4" v-for="banner in banners" :key="banner.docId">
            <div class="card">
                <div class="card-content" >
     
                    <div class="has-text-centered">
                      <a :href="banner.imageUrl" target="_blank">
                        <img :src="banner.imageUrl || '/static/placeholder_image.png'" alt="Placeholder image">            
                      </a>
                         <b-tag type="is-primary" rounded>  <p>{{banner.title}}</p></b-tag>   
                    </div>
 
            
                </div>
                <footer class="card-footer">
                    <a href="#" class="card-footer-item" @click="deleteBanner(banner)"> <b-tooltip label="Delete Photo" position="is-bottom"><b-icon type='is-primary' size="is-small" icon="trash"></b-icon> </b-tooltip></a>
                    <b-upload class="card-footer-item" v-model="files" @input="uploadImage(banner)">
                        <a>
                           <b-tooltip label="Upload Photo" position="is-bottom"><b-icon type='is-primary' size="is-small" icon="upload"></b-icon> </b-tooltip>
                        </a>
                    </b-upload>
                </footer>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import BannersService from './service';
import UploadService from '../../../lib/UploadService';

export default {
  name: 'banners',

  props: ['city'],

  created() {
    this.fetchBanners();
     
      this.$bus.$on('CITY_CHANGED', season => {
      // this.city = city;
       this.fetchBanners();
    });
  },

  data() {
    return {
      isLoading: true,
      banners: null,
      files: null
    };
  },

  methods: {
    fetchBanners() {
      BannersService.all(this.city.docId).then(data => {
        this.banners = data;
        this.isLoading = false;
      });
    },

    openAddBannerDialog() {
      this.$dialog.prompt({
        message: `Enter title`,
        inputAttrs: {
          placeholder: 'e.g. Sale!'
        },
        onConfirm: value => {
          this.isLoading = true;

          BannersService.add(this.city.docId, value).then(response => {
            const newBanner = {
              docId: response.id,
              name: value
            };

            this.banners.push(newBanner);
            this.isLoading = false;
            this.$toast.open(`Banner added successfully`);
          });
        }
      });
    },

    uploadImage(banner) {
      this.isLoading = true;

      UploadService(
        this.files[0],
        `hotels/${this.city.docId}/banners`,
        banner.docId
      )
        .then(() => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.open('Error saving image');
        });
    },

    deleteBanner(bannerToDelete) {
      this.isLoading = true;

      BannersService.deleteBanner(this.city.docId, bannerToDelete.docId).then(
        () => {
          this.isLoading = false;
          this.$toast.open('Image saved successfully');
          this.banners = this.banners.filter(
            banner => banner.docId !== bannerToDelete.docId
          );
        }
      );
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/hotel/Banners/Banners.vue